import { pathOr, pipe } from 'ramda';
import { usePromotionsStore } from '../../store';

export const selectHasPromotions = () =>
  pipe(pathOr(0, ['promotions', 'length']), (length) => length > 0);

export const useHasPromotions = () => usePromotionsStore(selectHasPromotions());
